export function isWormholeMessageId(thing) {
    return (thing.sequence !== undefined &&
        thing.emitter !== undefined &&
        thing.chain !== undefined);
}
export function isCircleMessageId(thing) {
    return thing.hash !== undefined;
}
export function isIbcMessageId(thing) {
    return (thing.dstChannel !== undefined &&
        thing.srcChannel !== undefined &&
        thing.chain !== undefined &&
        thing.srcPort !== undefined &&
        thing.dstPort !== undefined &&
        thing.sequence !== undefined);
}
//# sourceMappingURL=attestation.js.map